import React, { useState, useEffect, useRef } from "react";
import Loader from "../../../Common/Loader/loader";
import { AllOwnerTypeDetailsForSCV } from "../../../Apis/ownerTypeApi";
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import { getAllZoneWiseReport } from "../../../Apis/scvReports/reportedSCVApi";
import { getAllOverallScvTrips, getReportedSCVsAtTransferStationOverall } from "../../../Apis/scvReports/overallScvTripsApi";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import {
  AllTransferStationTransactions,
  AllTransferStationTotalTransactions,
  AllTransferStationTransactions1,
  GetSCVTripsToTS,
  GetSCVOverallTripsToTS,
} from "../../../Apis/TransferStationReport/allTransferStationTransactionApi";
import { useLocation, useNavigate } from "react-router-dom";

import {
  AllSecondaryDeploymentReport,
  AllSecondaryDeploymentTotalReport,
} from "../../../Apis/TransferStationReport/secondaryDeploymentTransactionReportApi";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import isGHMC, { formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { getNowDateTime, getOneMonthPastDateTime } from "../../AssetVehicle/utils/helpers";
import { CorporationStore } from "../../corporation_master/CorporationStore";
import Select from "react-select";
import TableSkeleton from "../../AllotedMaster/TableSkeleton";

const SCVReports = () => {
  // SCVs Overall Trips to TS/SCTP
  const DeployedFromDate = localStorage.getItem("DeployedFromDate");
  const DeployedFromDate1 = localStorage.getItem("DeployedFromDate1");
  const DeployedToDate = localStorage.getItem("DeployedToDate");
  const DeployedToDate1 = localStorage.getItem("DeployedToDate1");
  const DeployedOwnerType = localStorage.getItem("DeployedOwnerType");
  const DeployedVehicleType = localStorage.getItem("vehicleType");
  const CircleVehicleType = localStorage.getItem("circleVehicleType");
  const location = useLocation();
  const navigate = useNavigate();
   const currentDateTime = getCurrentDateTime();
    const currentDateWithStartTime = getStartOfCurrentDate();
  let dataPerPage = 5;
  const [isLoading, setIsLoading] = useState(false);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [ownerTypeDetailsTrips, setOwnerTypeDetailsTrips] = useState([]);
  const [zonesData, setZonesData] = useState([]);
  const [fromDate, setFromDate] = useState(
    DeployedFromDate || getStartOfCurrentDate()
  );
  const [fromDate1, setFromDate1] = useState(
    DeployedFromDate1 || getStartOfCurrentDate()
  );
  const [toDate, setToDate] = useState(DeployedToDate||getCurrentDateTime());
  const [toDate1, setToDate1] = useState(DeployedToDate1||getCurrentDateTime());
  const [selectedOwnerType, setSelectedOwnerType] = useState(
    DeployedOwnerType || ""
  );
  const [selectedVehicleType, setSelectedVehicleType] = useState(DeployedVehicleType || "");
  const [selectedCircleVehicleType, setSelectedCircleVehicleType] = useState(CircleVehicleType || "");
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [optionsValues, setOptionsValues] = useState([]);
  const [selectedOwnerTypeTrips, setSelectedOwnerTypeTrips] = useState("");
  // Initialize selectedTab from localStorage if available
  const savedTabFromStorage = localStorage.getItem("TripsselectedTab");
  const initialTab = savedTabFromStorage ? parseInt(savedTabFromStorage, 10) : 0;
  const [selectedTab, setSelectedTab] = useState(initialTab);
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const isInitialMount = useRef(true);
  const hasCalledApiForTab = useRef({ 0: false, 1: false });
  const [scvTripsData, setScvTripsData] = useState([]);
  const isProd = isGHMC();
  const { UserCorporations, fetchUserCorporations } = CorporationStore();
  const [selectedCorporation, setSelectedCorporation] = useState([]);
  const [selectedCorporation1, setSelectedCorporation1] = useState([]);

  useEffect(() => {
    // Reset API call flags when component mounts (including when navigating back)
    // This ensures the API is called for the selected tab when navigating back
    hasCalledApiForTab.current = { 0: false, 1: false };
    isInitialMount.current = true;
  }, []);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    localStorage.setItem("TripsselectedTab", index);
    // Reset the flag for the newly selected tab so API is called
    hasCalledApiForTab.current[index] = false;
  };

  const navigateToViewOverallTrips = (tripData, startDate, endDate, hideDeployedColumns = false) => {
    navigate("/view-overall-trips", {
      state: {
        data: tripData,
        fromDate: startDate,
        toDate: endDate,
        hideDeployedColumns,
      },
    });
  };

  const fetchOwnerTypeData = async (fDate, tDate) => {
    try {
      const fromDateOnly = (fDate || fromDate).split("T")[0];
      const toDateOnly = (tDate || toDate).split("T")[0];
      const ownerTypeData = await AllOwnerTypeDetailsForSCV(fromDateOnly, toDateOnly);
      const normalizedData = Array.isArray(ownerTypeData)
        ? ownerTypeData
        : ownerTypeData?.data || ownerTypeData?.result || [];
      setOwnerTypeDetails(normalizedData);
      setOwnerTypeDetailsTrips(normalizedData);
    } catch (error) {
      console.error("Error fetching owner type data:", error);
    }
  };

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);

  useEffect(() => {
    setVehicleTypeOptionsValues(vehicleTypeDetails.map(vehicleType => ({
      value: vehicleType.vehicleTypeId,
      label: vehicleType.vehicleTypeName,
    })));
  }, [vehicleTypeDetails]);

  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedVehicleType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  useEffect(() => {
    fetchUserCorporations();
  }, []);

  useEffect(() => {
    fetchOwnerTypeData(fromDate, toDate);
  }, [fromDate, toDate]);

  useEffect(() => {
    // Set initial fromDate and toDate from location state
    if (location.state) {
      const { fromDate: startDate, toDate: endDate } = location.state;
      setFromDate(startDate);
      setToDate(endDate);
    }
  }, [location.state]);

  // Fetch zone-wise data only when Tab 0 is selected
  useEffect(() => {
    // Only call API for the selected tab, and only if we haven't called it yet for this tab selection
    if (selectedTab === 0 && !hasCalledApiForTab.current[0]) {
      fetchData();
      hasCalledApiForTab.current[0] = true;
    } else if (selectedTab === 1 && !hasCalledApiForTab.current[1]) {
      fetchOverallData();
      hasCalledApiForTab.current[1] = true;
    }
    isInitialMount.current = false;
  }, [selectedTab]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      localStorage.setItem("DeployedFromDate", fromDate);
      localStorage.setItem("DeployedToDate", toDate);
      localStorage.setItem("vehicleType", selectedVehicleType);
      localStorage.setItem("DeployedOwnerType", selectedOwnerType);
      const response = await getAllZoneWiseReport(fromDate, toDate, selectedVehicleType, selectedOwnerType, selectedCorporation);
      setZonesData(response.data);
    } catch (error) {
      console.error("Error fetching zone wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    fetchData();
  };
  const handleZoneClick = async (row) => {
    localStorage.setItem("zone", row.zoneId);
    navigate("/view-inner-scv-circle-report", { state: {formatFromDate:fromDate,formatToDate:toDate} });
  };

  const handleTotalTrip = async (zoneId) => {
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching circle wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTotalTripForTotal = async (zoneId) => {
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching circle wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTotalDeploymentClick = async () => {
    setIsOptionsLoading(true);
    try {
      const response = await AllSecondaryDeploymentTotalReport(
        fromDate,
        toDate,
        selectedOwnerType,
        selectedVehicleType,
        ""
      );
      navigate("/view-deployed-trips", {
        state: { data: response.data, fromDate, toDate },
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleDeploymentClick = async (row) => {
    try {
      setIsLoading(true);
      let response;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllSecondaryDeploymentReport(
          fromDate,
          toDate,
          row.zoneId,
          row.circleId, // Pass empty string for circleId
          selectedOwnerType,
          "",
          selectedVehicleType,
          ""
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await AllSecondaryDeploymentReport(
          fromDate,
          toDate,
          row.zoneId,
          "", // Pass circleId,
          selectedOwnerType,
          "",
          selectedVehicleType,

          ""
        );
      }
      // Navigate to the desired page and pass the data as state
      navigate("/view-deployed-trips", {
        state: { data: response.data, fromDate, toDate },
      });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Set initial fromDate and toDate from location state
    if (location.state) {
      const { fromDate: startDate, toDate: endDate } = location.state;
      setFromDate(startDate);
      setToDate(endDate);
    }
  }, [location.state]);

  const scvReportColumns = [
    {
      name: "S.No",
      width: "70px",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      cell: (row) => <span>{row["corporationName"]}</span>,
      sortable: true,
    },
    {
      name: "Zone",

      selector: (row) => row["zoneName"],
      cell: (row) => (
        <span
          style={{ color: `${row.zoneName === "Total" ? "black" : "blue"}`, cursor: "pointer" }}
          onClick={() => row.zoneName != "Total" && handleZoneClick(row)}
        >
          {row["zoneName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Deployment",
      selector: (row) =>
        row["deployment"] ?? row["Deployment"] ?? row["deploymentCount"] ?? row["deployedCount"],
      cell: (row) => {
        const deploymentValue =
          row["deployment"] ?? row["Deployment"] ?? row["deploymentCount"] ?? row["deployedCount"];
        return (
          <span
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => {
              if (row.zoneName === "Total") {
                handleTotalDeploymentClick();
              } else {
                handleDeploymentClick(row);
              }
            }}
          >
            {deploymentValue}
          </span>
        );
      },
      sortable: true,
    },
    {
      name: (
        <>
          Reported At <br />
          TS/SCTP
        </>
      ),
      // width: "8%",
      selector: (row) => row["reportedAtTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtTsTotalClick();
            } else {
              handleReportedAtTsZoneClick(row);

            }
          }}
        >
          {row["reportedAtTS"]}
        </span>
      ),
      //    sortable: true,
      // width: "120px",
    },
    {
      name: "Total Trips",
      width: "140px",
      selector: (row) => row["totalTrips"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalTripForTotal();
            } else {
              handleTotalTrip(row["zoneId"]);
            }
          }}
        >
          {" "}
          {row["totalTrips"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Trip-1",
      width: "120px",
      selector: (row) => row["oneTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleOneTripTotalClick();
            } else {
              handleOneTripClick(row["zoneId"]);
            }
          }}
        >
          {row["oneTrip"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Trip-2",
      width: "120px",
      selector: (row) => row["twoTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTwoTripTotalClick();
            } else {
              handleTwoTripClick(row["zoneId"]);
            }
          }}
        >
          {row["twoTrip"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Trip-3",
      width: "120px",
      selector: (row) => row["threeTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleThreeTripTotalClick();
            } else {
              handleThreeTripClick(row["zoneId"]);
            }
          }}
        >
          {row["threeTrip"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Trip-4",
      width: "120px",
      selector: (row) => row["fourTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleFourTripTotalClick();
            } else {
              handleFourTripClick(row["zoneId"]);
            }
          }}
        >
          {row["fourTrip"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: ">05 Trip",
      width: "120px",
      selector: (row) => row["moreThanFiveTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleMoreThanFourTripTotalClick();
            } else {
              handleMoreThanFourTripClick(row["zoneId"]);
            }
          }}
        >
          {row["moreThanFiveTrip"]}
        </span>
      ),
      sortable: true,
    },
  ];

  const handleOneTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 1
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOneTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 1
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTwoTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 2
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTwoTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 2
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleThreeTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 3
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleThreeTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 3
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleFourTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      // Call a different API for the total of the column
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 4
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleFourTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 4
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleMoreThanFourTripClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        ZoneId: zoneId,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 5
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMoreThanFourTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      // Call a different API for the total of the column
      const param = {
        StartDate: fromDate,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerType,
        VehicleTypeId: selectedVehicleType,
        TripTypeId: 5
      }
      const response = await GetSCVTripsToTS(param);
      navigate("/deployed-trips-tssctp",{ state: {data:response.data,fromDate:fromDate,toDate:toDate} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  localStorage.setItem("fromDate", fromDate);
  localStorage.setItem("toDate", toDate);

  const option = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTimes = ` ${new Date()
    .toLocaleString("en-GB", option)
    .replace(/\//g, "/")}`;


  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `SCVs Deployed Trips Reports`;
    const downloadDateTime = `Reported on: ${generationTimes}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 10);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells
    for (let col = 2; col <= 10; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add the heading
    worksheet.addRow(["", "", "SCVs Deployed Trips Reports", ""]);
    worksheet.mergeCells(2, 2, 2, 10);
    worksheet.getCell(2, 2).value = `SCVs Deployed Trips Reports on ${fromDate ? formatDateTimeWithoutSec(fromDate) : getCurrentDateTime()} To ${toDate ? formatDateTimeWithoutSec(toDate) : getCurrentDateTime()} (at ${getCurrentDateTime1()})`;;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells
    for (let col = 2; col <= 10; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Corporation",
      "Zone",
      "Deployment",
      "Reported At TS/SCTP",
      "Total Trips",
      "Trip-1",
      "Trip-2",
      "Trip-3",
      "Trip-4",
      ">05 Trip",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 13) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Initialize totals
    let totalDeployment = 0;
    let totalReportedAtTS = 0;
    let totalTrips = 0;
    let totalOneTrip = 0;
    let totalTwoTrip = 0;
    let totalThreeTrip = 0;
    let totalFourTrip = 0;
    let totalMoreThanFiveTrip = 0;

    // Add data rows and accumulate totals
    zonesData.forEach((item, index) => {
      const deploymentValue =
        item.deployment ?? item.Deployment ?? item.deploymentCount ?? item.deployedCount ?? "N/A";
      worksheet
        .addRow([
          index + 1,
          item.corporationName,
          item.zoneName,
          deploymentValue,
          item.reportedAtTS,
          item.totalTrips,
          item.oneTrip,
          item.twoTrip,
          item.threeTrip,
          item.fourTrip,
          item.moreThanFiveTrip,
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 13) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "left" };
          }
        });

      // Accumulate totals
      totalDeployment += item.deployment || 0;
      totalReportedAtTS += item.reportedAtTS || 0;
      totalTrips += item.totalTrips || 0;
      totalOneTrip += item.oneTrip || 0;
      totalTwoTrip += item.twoTrip || 0;
      totalThreeTrip += item.threeTrip || 0;
      totalFourTrip += item.fourTrip || 0;
      totalMoreThanFiveTrip += item.moreThanFiveTrip || 0;
    });

    // Add total row (without S.No)
    const totalRow = worksheet.addRow([
      "", // Leave S.No empty for the total row
      "", // Corporation empty for total row
      "Total", // The label for the total row
      totalDeployment,
      totalReportedAtTS,
      totalTrips,
      totalOneTrip,
      totalTwoTrip,
      totalThreeTrip,
      totalFourTrip,
      totalMoreThanFiveTrip,
    ]);

    totalRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont; // Make total row bold
      cell.alignment = { horizontal: "left" }; // Center align the content
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVsDeployedTripsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const calculateSCVTotals = (data) => {
    const totals = {
      sno: "",
      zoneName: "Total",
      deployment: 0,
      reportedAtTS: 0,
      totalTrips: 0,
      oneTrip: 0,
      twoTrip: 0,
      threeTrip: 0,
      fourTrip: 0,
      moreThanFiveTrip: 0,
    };

    data.forEach((row) => {
      const deploymentValue =
        row.deployment ?? row.Deployment ?? row.deploymentCount ?? row.deployedCount ?? 0;
      totals.deployment += deploymentValue;
      totals.reportedAtTS += row.reportedAtTS || 0;
      totals.totalTrips += row.totalTrips || 0;
      totals.oneTrip += row.oneTrip || 0;
      totals.twoTrip += row.twoTrip || 0;
      totals.threeTrip += row.threeTrip || 0;
      totals.fourTrip += row.fourTrip || 0;
      totals.moreThanFiveTrip += row.moreThanFiveTrip || 0;
    });
    return totals;
  };

  const totalZoneRow = calculateSCVTotals(zonesData);
  const scvDataWithTotal = [...zonesData, totalZoneRow];

  const scvReportTripsColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      //   sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      cell: (row) => <span>{row["corporationName"]}</span>,
      width: "140px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      // width:'9%',
      cell: (row) => <span>{row["zoneName"]}</span>,
      //    sortable: true,
      width: "120px",
    },
    {
      name: "Circle",
      // width:'9%',
      selector: (row) => row["circleName"],
      cell: (row) => <span>{row["circleName"]}</span>,
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>Transfer Station</>,
      // width:'10%',
      selector: (row) => row["transferStationName"],
      cell: (row) => <span>{row["transferStationName"]}</span>,
      //   sortable: true,
      // width: "120px",
    },
    {
      name: (
        <>
          Reported At <br />
          TS/SCTP
        </>
      ),
      // width: "8%",
      selector: (row) => row["reportedAtTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtTsTotalClick();
            } else {
              handleReportedAtTsClick(row);

            }
          }}
        >
          {row["reportedAtTS"]}
        </span>
      ),
      //    sortable: true,
      // width: "120px",
    },
    {
      name: "Total Trips",
      width: "8%",
      selector: (row) => row["totalTrips"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalTripsClickColumn();
            } else {
              handleTotalTripsClick(row);
            }
          }}
        >
          {row["totalTrips"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: "Trip-1",
      width: "8%",
      selector: (row) => row["oneTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleOneSCVTripTotalClick();
            } else {
              handleOneSCVTripClick(row);
            }
          }}
        >
          {row["oneTrip"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: "Trip-2",
      width: "8%",
      selector: (row) => row["twoTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTwoTripSCVTotalClick();
            } else {
              handleTwoSCVTripClick(row);
            }
          }}
        >
          {row["twoTrip"]}
        </span>
      ),
      //   sortable: true,
      width: "120px",
    },
    {
      name: "Trip-3",
      width: "8%",
      selector: (row) => row["threeTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleThreeTripTotalSCVClick();
            } else {
              handleThreeSCVTripClick(row);
            }
          }}
        >
          {row["threeTrip"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: "Trip-4",
      width: "8%",
      selector: (row) => row["fourTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleFourTripSCVTotalClick();
            } else {
              handleFourSCVTripClick(row);
            }
          }}
        >
          {row["fourTrip"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: ">05 Trip",
      width: "10%",
      selector: (row) => row["moreThanFiveTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleMoreThanFourSCVTripTotalClick();
            } else {
              handleMoreThanFourSCVTripClick(row);
            }
          }}
        >
          {row["moreThanFiveTrip"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
  ];

  const handleOneSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "1",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleOneSCVTripTotalClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        // CircleId:row.circleId,
        TripTypeId: "1",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleTwoSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "2",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleTwoTripSCVTotalClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        TripTypeId: "2",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleThreeSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "3",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleThreeTripTotalSCVClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        // CircleId:row.circleId,
        TripTypeId: "3",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFourSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "4",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFourTripSCVTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        TripTypeId: "4",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleMoreThanFourSCVTripClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId,
        TripTypeId: "5",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleMoreThanFourSCVTripTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        TripTypeId: "5",
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const exportToExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `SCVs Overall Trips to TS/SCTP on ${fromDate1 ? formatDateTimeWithoutSec(fromDate1) : getCurrentDateTime()} To ${toDate1 ? formatDateTimeWithoutSec(toDate1) : getCurrentDateTime()}  (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Reported on: ${generationTimes}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 10);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add "SCVs Overall Trips Reports" to the worksheet
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(2, 2, 2, 10);
    worksheet.getCell(2, 2).value = cumulativeHeadingReport;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Add an empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Corporation",
      "Zone",
      "Circle",
      "Transferstation",
      // "Deployment",
      "Reported At TS/SCTP",
      "Total Trips",
      "Trip-1",
      "Trip-2",
      "Trip-3",
      "Trip-4",
      ">05 Trip",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 10) {
        // Apply background color to header cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    scvTripsData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.corporationName ?? "N/A",
          item.zoneName ?? "N/A",
          item.circleName ?? "N/A",
          item.transferStationName ?? "N/A",
          // item.deployment ?? "N/A",
          item.reportedAtTS ?? "N/A",
          item.totalTrips ?? "N/A",
          item.oneTrip ?? "N/A",
          item.twoTrip ?? "N/A",
          item.threeTrip ?? "N/A",
          item.fourTrip ?? "N/A",
          item.moreThanFiveTrip ?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 14) {
            // Align the columns from 1 to 10 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Calculate the totals for the report
    const totalRow = calculateSCVOverallTotals(scvTripsData);

    // Add the total row (without S.No for total)
    worksheet.addRow([
      "", // Leave S.No empty for total row
      "", // Corporation empty for total row
      "",
      "",
      "Total", // Label the total row
      // totalRow.deployment,
      totalRow.reportedAtTS,
      totalRow.totalTrips,
      totalRow.oneTrip,
      totalRow.twoTrip,
      totalRow.threeTrip,
      totalRow.fourTrip,
      totalRow.moreThanFiveTrip,
    ]);

    // Style the total row (bold font, centered alignment)
    worksheet.lastRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Center align the total row
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 }, // S.No
      { width: 20 }, // Zone
      { width: 20 }, // Deployment
      { width: 20 }, // Zone
      { width: 20 }, // Deployment
      { width: 20 }, // Reported At TS/SCTP
      { width: 20 }, // Total Trips
      { width: 20 }, // Trip-1
      { width: 20 }, // Trip-2
      { width: 20 }, // Trip-3
      { width: 20 }, // Trip-4
      { width: 20 }, // >05 Trip
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVsOverallTripsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleReportedAtTsTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      const ownerTypeId = selectedOwnerType;
      const vehicleTypeId = selectedVehicleType;
      const startDate = fromDate;
      const endDate = toDate;
      const response = await AllTransferStationTotalTransactions(
        startDate,
        endDate,
        "2",
        ownerTypeId,
        vehicleTypeId,
        ""
      );

      navigateToViewOverallTrips(
        response.data,
        startDate,
        endDate,
        selectedTab === 1
      );
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleReportedAtTsClick = async (row) => {
    try {
      setIsLoading(true);
      let response;
      const circleId = row.circleId ? row.circleId : "";
      const zoneId = row.zoneId ? row.zoneId : "";
      const transferStationId = row.transferStationId ? row.transferStationId : "";
      if (row.zoneId !== "" && row.circleId === "") {
        response = await getReportedSCVsAtTransferStationOverall(
          fromDate1,
          toDate1,
          "",
          zoneId,
          circleId,
          "2",
          selectedOwnerTypeTrips,
          selectedCircleVehicleType,
          row.transferStationId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await getReportedSCVsAtTransferStationOverall(
          fromDate1,
          toDate1,
          "",
          "",
          "",
          2,
          selectedOwnerTypeTrips,
          selectedCircleVehicleType,
          transferStationId
        );
      }
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const handleReportedAtTsZoneClick = async (row) => {
    try {
      setIsLoading(true);
      let response;
      const circleId = row.circleId ? row.circleId : ""; // Ensure it's always a valid string
      const zoneId = row.zoneId ? row.zoneId : ""; // Ensure it's always a valid string
      const transferStationId = row.transferStationId ? row.transferStationId : "";
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllTransferStationTransactions1(
          fromDate, //start date
          toDate, //end date
          "", //VehicleNumber
          zoneId, //zoneId,
          circleId, //circleId
          "2", //collectionTypeId
          selectedOwnerType, //ownerTypeId (Tab 0 - Deployed Trips)
          selectedVehicleType, //vehicleTypeId (Tab 0 - Deployed Trips)
          row.transferStationId //transferStationId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await AllTransferStationTransactions1(
          fromDate, //start date
          toDate, //end date
          "", //VehicleNumber
          zoneId, //zoneId,
          "", //circleId
          "2", //collectionTypeId
          selectedOwnerType, //ownerTypeId (Tab 0 - Deployed Trips)
          selectedVehicleType, //vehicleTypeId (Tab 0 - Deployed Trips)
          transferStationId //transferStationId
        );
      }
      navigateToViewOverallTrips(response.data, fromDate, toDate, false);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTotalTripsClickColumn = async () => {
    setIsOptionsLoading(true);
    try {
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,

      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalTripsClick = async (row) => {
    try {
      setIsLoading(true);
      const param = {
        StartDate: fromDate1,
        EndDate: toDate1,
        TransferStationId: row.transferStationId,
        OwnerTypeId: selectedOwnerTypeTrips,
        VehicleTypeId: selectedCircleVehicleType,
        CircleId: row.circleId
      }
      const response = await GetSCVOverallTripsToTS(param);
      navigateToViewOverallTrips(response.data, fromDate1, toDate1, true);
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const calculateSCVOverallTotals = (data) => {
    const totals = {
      sno: "Total",
      zoneName: "Total",
      deployment: 0,
      reportedAtTS: 0,
      totalTrips: 0,
      oneTrip: 0,
      twoTrip: 0,
      threeTrip: 0,
      fourTrip: 0,
      moreThanFiveTrip: 0,
    };

    data.forEach((row) => {
     
      totals.deployment += row.deployment || 0;
      totals.reportedAtTS += row.reportedAtTS || 0;
      console.log( totals.reportedAtTS )
      totals.totalTrips += row.totalTrips || 0;
      totals.oneTrip += row.oneTrip || 0;
      totals.twoTrip += row.twoTrip || 0;
      totals.threeTrip += row.threeTrip || 0;
      totals.fourTrip += row.fourTrip || 0;
      totals.moreThanFiveTrip += row.moreThanFiveTrip || 0;
    });
    return totals;
  };
  const totalOveraallRow = calculateSCVOverallTotals(scvTripsData);
  const scvOverallDataWithTotal = [...scvTripsData, totalOveraallRow];

  const fetchOverallData = async () => {
    try {
      setIsLoading(true);
      const response = await getAllOverallScvTrips(fromDate1, toDate1, selectedOwnerTypeTrips, selectedCircleVehicleType, selectedCorporation1);
      setScvTripsData(response.data);
    } catch (error) {
      console.error("Error fetching overall SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOverallSearch = () => {
    fetchOverallData(); // Call fetchData when the search button is clicked
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 className="text-start mb-3">SCVs Trips to TS/SCTP</h4>
            <div className="row">
              <div className="col">
                <div className="">
                  <div className="row mb-5">
                    <div className="col-xl-12 col-md-12">
                      <div className="card">
                        <div className="card-body">
                          <Tabs
                            selectedIndex={selectedTab}
                            onSelect={handleTabSelect}
                          >
                            <TabList style={{ display: "none" }}>
                              <Tab />
                              <Tab />
                            </TabList>
                            <div
                              style={{
                                position: "relative",
                                display: "inline-flex",
                                backgroundColor: "#f1f3f5",
                                borderRadius: "8px",
                                border: "1px solid #e4e6e9",
                                padding: "4px",
                                marginBottom: "16px",
                                overflow: "hidden",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  top: "4px",
                                  bottom: "4px",
                                  left: selectedTab === 0 ? "4px" : "calc(50% + 2px)",
                                  width: "calc(50% - 6px)",
                                  borderRadius: "5px",
                                  backgroundColor: isProd ? "#1565C0" : "#c0392b",
                                  boxShadow: "0 1px 6px rgba(0,0,0,0.18)",
                                  transition: "left 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                                  zIndex: 0,
                                }}
                              />
                              <button
                                type="button"
                                onClick={() => handleTabSelect(0)}
                                style={{
                                  padding: "7px 18px",
                                  background: "transparent",
                                  border: "none",
                                  outline: "none",
                                  cursor: "pointer",
                                  fontWeight: selectedTab === 0 ? "600" : "500",
                                  fontSize: "13px",
                                  color: selectedTab === 0 ? "#fff" : "#6c757d",
                                  position: "relative",
                                  zIndex: 1,
                                  transition: "color 0.35s ease",
                                  userSelect: "none",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <i className="fa-solid fa-layer-group me-2" />
                                Deployed Trips
                              </button>
                              <button
                                type="button"
                                onClick={() => handleTabSelect(1)}
                                style={{
                                  padding: "7px 18px",
                                  background: "transparent",
                                  border: "none",
                                  outline: "none",
                                  cursor: "pointer",
                                  fontWeight: selectedTab === 1 ? "600" : "500",
                                  fontSize: "13px",
                                  color: selectedTab === 1 ? "#fff" : "#6c757d",
                                  position: "relative",
                                  zIndex: 1,
                                  transition: "color 0.35s ease",
                                  userSelect: "none",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <i className="fa-solid fa-circle-dot me-2" />
                                Overall Trips
                              </button>
                            </div>
                            <TabPanel>
                              <div className="row align-items-center  mt-3">
                                <div className="col-md-12">
                                  <div className="row text-start">
                                    <div className="col-md-2">
                                      <label htmlFor="fromDate">
                                        From Date & Time:
                                      </label>
                                      <input
                                        type="datetime-local"
                                        id="fromDate"
                                        style={inputStyle}
                                        className="form-control"
                                        value={fromDate}
                                        min={getOneMonthPastDateTime()}
                                        max={getNowDateTime()}
                                      
                                        onChange={(e) => {
                                          setFromDate(e.target.value);
                                          localStorage.setItem(
                                            "DeployedFromDate",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <label htmlFor="toDate">
                                        To Date & Time:
                                      </label>
                                      <input
                                        type="datetime-local"
                                        id="toDate"
                                        className="form-control"
                                        style={inputStyle}
                                        value={toDate}
                                        min={fromDate}
                                        // max={getCurrentDateTime()}
                                        onChange={(e) => {
                                          setToDate(e.target.value);
                                          localStorage.setItem(
                                            "DeployedToDate",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>
                                    {/* <div className="text-start" style={{ flex: "0 0 130px" }}>
                                      <label htmlFor="VehicleTypeId">Vehicle Type</label>
                                      <select
                                        className="form-select"
                                        // style={{ backgroundColor: "#fff" }}
                                        name="vehicleTypeId"
                                        value={selectedVehicleType}
                                        // id="vehicleTypeId"
                                        // onChange={(e) => setVehicleTypeId(e.target.value)}
                                        style={inputStyle2}
                                        // name="vehicleTypeId"
                                        id="vehicleType"
                                        // value={selectedOwnerType}
                                        onChange={(e) => {
                                          setSelectedVehicleType(e.target.value);
                                          localStorage.setItem(
                                            "vehicleType",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="">All</option>
                                        {vehicleTypeDetails
                                          .filter((vehicle) => vehicle.isActive)
                                          .map((vehicle) => (
                                            <option
                                              key={vehicle.vehicleTypeId}
                                              value={vehicle.vehicleTypeId}
                                            >
                                              {vehicle.vehicleTypeName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>*/}
                                    <div className="text-start" style={{ flex: "0 0 130px" }}>
                                      <label htmlFor="Owner type">
                                        Owner Type
                                      </label>
                                      <select
                                        className="form-select"
                                        style={inputStyle2}
                                        name="ownerTypeId"
                                        id="ownerType"
                                        value={selectedOwnerType}
                                        onChange={(e) => {
                                          setSelectedOwnerType(e.target.value);
                                          localStorage.setItem(
                                            "DeployedOwnerType",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="">All</option>
                                        {ownerTypeDetails
                                          .filter((ownerType) => ownerType.isActive !== false)
                                          .map((ownerType) => (
                                            <option
                                              key={ownerType.ownerTypeId}
                                              value={ownerType.ownerTypeId}
                                            >
                                              {ownerType.ownerTypeName}
                                            </option>
                                          ))}
                                      </select>
                                    </div> 
                                    <div className="col-md-3">
                                      <label htmlFor="corporationId">Corporation</label>
                                      <Select
                                        inputId="corporationId"
                                        isMulti
                                        options={UserCorporations.map((corp) => ({
                                          value: corp.corporationId,
                                          label: corp.corporationName,
                                        }))}
                                        value={UserCorporations.filter((corp) =>
                                          selectedCorporation.includes(corp.corporationId)
                                        ).map((corp) => ({
                                          value: corp.corporationId,
                                          label: corp.corporationName,
                                        }))}
                                        onChange={(selected) =>
                                          setSelectedCorporation((selected || []).map((c) => c.value))
                                        }
                                        placeholder="Select Corporation(s)"
                                        isClearable
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        styles={{
                                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                          control: (base) => ({
                                            ...base,
                                            borderRadius: "0px",
                                            backgroundColor: "#ececec",
                                            border: "1px solid #E2E2E2",
                                            minHeight: "38px",
                                          }),
                                          placeholder: (base) => ({
                                            ...base,
                                            marginLeft: "6px",
                                          }),
                                          indicatorSeparator: (base) => ({
                                            ...base,
                                            backgroundColor: "#fff",
                                          }),
                                        }}
                                      />
                                    </div>

                                    <div className="col-md-3 ms-auto ">
                                      <label className="form-label w-100">&nbsp;</label>
                                      <div className="d-flex gap-2">
                                        <button
                                          className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                                          onClick={handleSearch}
                                        >
                                          Search
                                        </button>
                                        <button
                                          className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                                          onClick={() => {
                                            localStorage.setItem("DeployedFromDate", getStartOfCurrentDate());
                                            localStorage.setItem("DeployedToDate", getCurrentDateTime());
                                            localStorage.setItem("vehicleType", "");
                                            localStorage.setItem("DeployedOwnerType", "");
                                            setFromDate(getStartOfCurrentDate());
                                            setToDate(getCurrentDateTime());
                                            setSelectedOwnerType("");
                                            setSelectedVehicleType("");
                                            setSelectedCorporation([]);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          className="btn btn-excel"
                                          onClick={downloadAsExcel}
                                        >
                                          <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                                          Excel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="card mt-3">
                                <div className="">
                                  <div className="top-header">
                                    <span> SCVs Deployed Trips TS/SCTP
                                      ({fromDate ? formatDateTimeWithoutSec(fromDate) : getCurrentDateTime()} To {toDate ? formatDateTimeWithoutSec(toDate) : getCurrentDateTime()}) (at {getCurrentDateTime1()})
                                    </span>
                                  </div>
                                 { isLoading ? <TableSkeleton /> : (
                                  <CustomDataTable
                                    data={scvDataWithTotal}
                                    columns={scvReportColumns}

                                  // headers={headers}
                                  // link={true}
                                  // search={true}
                                  // fromDate={fromDate}
                                  // toDate={toDate}
                                  />)}
                                </div>
                              </div>
                            </TabPanel>
                            <TabPanel>
                              <div className="row justify-content-between align-items-center  mt-3">
                                <div className="col-md-12">
                                  <div className="row text-start">
                                    <div className="col-md-2">
                                      <label
                                        htmlFor="fromDate"
                                      >
                                        From Date & Time:
                                      </label>
                                      <input
                                        type="datetime-local"
                                        name="fromDate1"
                                        style={inputStyle}
                                        className="form-control"
                                        value={fromDate1}
                                        min={getOneMonthPastDateTime()}
                                        max={getNowDateTime()}

                                        onChange={(e) => {
                                          setFromDate1(e.target.value);
                                          localStorage.setItem(
                                            "DeployedFromDate1",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>

                                    <div className="col-md-2">
                                      <label
                                        htmlFor="toDate"
                                      >
                                        To Date & Time:
                                      </label>
                                      <input
                                        type="datetime-local"
                                        name="toDate"
                                        className="form-control"
                                        style={inputStyle}
                                        value={toDate1}
                                        min={fromDate1}
                                        // max={getCurrentDateTime()}
                                        onChange={(e) => {
                                          setToDate1(e.target.value);
                                          localStorage.setItem(
                                            "DeployedToDate1",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>

                                    {/* <div className="col-md-2">
                                      <label htmlFor="VehicleTypeId">Vehicle Type</label>
                                      <select
                                        className="form-select"
                                        // style={{ backgroundColor: "#fff" }}
                                        name="circleVehicleTypeId"
                                        value={selectedCircleVehicleType}
                                        // id="vehicleTypeId"
                                        // onChange={(e) => setVehicleTypeId(e.target.value)}
                                        style={inputStyle2}
                                        // name="vehicleTypeId"
                                        id="circleVehicleType"
                                        // value={selectedOwnerType}
                                        onChange={(e) => {
                                          setSelectedCircleVehicleType(e.target.value);
                                          localStorage.setItem(
                                            "circleVehicleType",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="">All</option>
                                        {vehicleTypeDetails
                                          .filter((vehicle) => vehicle.isActive)
                                          .map((vehicle) => (
                                            <option
                                              key={vehicle.vehicleTypeId}
                                              value={vehicle.vehicleTypeId}
                                            >
                                              {vehicle.vehicleTypeName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>*/}
                                    <div className="col-md-2">
                                      <label
                                        htmlFor="Owner type"
                                      >
                                        Owner Type
                                      </label>
                                      <select
                                        className="form-select"
                                        style={inputStyle2}
                                        name="ownerTypeId"
                                        id="ownerType"
                                        value={selectedOwnerTypeTrips}
                                        onChange={(e) => {
                                          setSelectedOwnerTypeTrips(
                                            e.target.value
                                          );
                                          localStorage.setItem(
                                            "OverallOwnerType ",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="">All</option>
                                        {ownerTypeDetailsTrips
                                          .filter((ownerType) => ownerType.isActive !== false)
                                          .map(
                                            (ownerType) => (
                                              <option
                                                key={ownerType.ownerTypeId}
                                                value={ownerType.ownerTypeId}
                                              >
                                                {ownerType.ownerTypeName}
                                              </option>
                                            )
                                          )}
                                      </select>
                                    </div> 
                                    <div className="col-md-3">
                                      <label htmlFor="corporationId1">Corporation</label>
                                      <Select
                                        inputId="corporationId1"
                                        isMulti
                                        options={UserCorporations.map((corp) => ({
                                          value: corp.corporationId,
                                          label: corp.corporationName,
                                        }))}
                                        value={UserCorporations.filter((corp) =>
                                          selectedCorporation1.includes(corp.corporationId)
                                        ).map((corp) => ({
                                          value: corp.corporationId,
                                          label: corp.corporationName,
                                        }))}
                                        onChange={(selected) =>
                                          setSelectedCorporation1((selected || []).map((c) => c.value))
                                        }
                                        placeholder="Select Corporation(s)"
                                        isClearable
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        styles={{
                                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                          control: (base) => ({
                                            ...base,
                                            borderRadius: "0px",
                                            backgroundColor: "#ececec",
                                            border: "1px solid #E2E2E2",
                                            minHeight: "38px",
                                          }),
                                          placeholder: (base) => ({
                                            ...base,
                                            marginLeft: "6px",
                                          }),
                                          indicatorSeparator: (base) => ({
                                            ...base,
                                            backgroundColor: "#fff",
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="col-md-4 ms-auto">
                                      <label className="form-label w-100">&nbsp;</label>
                                      <div className="d-flex gap-2">
                                        <button
                                          className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                                          onClick={handleOverallSearch}
                                        >
                                          Search
                                        </button>
                                        <button
                                          className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                                          onClick={() => {
                                            localStorage.removeItem("DeployedFromDate1");
                                            localStorage.removeItem("DeployedToDate1");
                                            localStorage.removeItem("OverallOwnerType");
                                            localStorage.removeItem("circleVehicleType");
                                            setFromDate1(getStartOfCurrentDate());
                                            setToDate1(getCurrentDateTime());
                                            setSelectedOwnerTypeTrips("");
                                            setSelectedCircleVehicleType("");
                                            setSelectedCorporation1([]);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          className="btn btn-excel"
                                          onClick={exportToExcel}
                                        >
                                          <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                                          Excel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="card mt-3">
                                <div className="top-header">
                                  <span> SCVs Overall Trips to TS/SCTP  
                                    ({fromDate1 ? formatDateTimeWithoutSec(fromDate1) : getCurrentDateTime()} To {toDate1 ? formatDateTimeWithoutSec(toDate1) : getCurrentDateTime()})  (at {getCurrentDateTime1()})</span>
                                </div>
                                <CustomDataTable
                                  data={scvOverallDataWithTotal}
                                  columns={scvReportTripsColumns}
                                  dataPerPage={dataPerPage}
                                />
                              </div>
                            </TabPanel>
                          </Tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};
// Function to get default date in "YYYY-MM-DDTHH:MM" format
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};
// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export default SCVReports;

const inputStyle = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};

const inputStyle2 = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  // padding: "15px",
  borderRadius: "0px",
};
